import { render } from "./AuthSimpleLayout.vue?vue&type=template&id=7b61f6a3&scoped=true"
const script = {}

import "./AuthSimpleLayout.vue?vue&type=style&index=0&id=7b61f6a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b61f6a3"]])

export default __exports__